// this is an autogenerated file from DesignSystem/TasksAssignee/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksAssignee($assignee_id: uuid!) {
  users_by_pk(id: $assignee_id) {
    id
    vaxiom_person {
      id
      first_name
      last_name
    }
  }
}

`